import { ELinks, ILinkContentWithLink } from '@/shared/types/Links'
import { linkContent, moreLinks } from '../constants/linkContent'

const mapLinkKeyToContent = (linkId: ELinks): ILinkContentWithLink => ({
  ...linkContent[linkId],
  link: moreLinks[ELinks[linkId]],
  id: linkId,
})

export default mapLinkKeyToContent